import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { caseDisclaimer } from "../data/cases";
import { useLang } from "../i18n";
import { SafeImage } from "./Media";

export const CaseCard = ({ c, heading = "h3" }) => {
  const { t, href } = useLang();
  const Heading = heading;
  const workCount = (c.gallery?.length || 0) + (c.videos?.length || 0);

  return (
    <Link
      to={href(`/work/${c.slug}`)}
      data-testid={`case-card-${c.slug}`}
      className="portfolio-card group block"
    >
      <div className="portfolio-card-media">
        <SafeImage
          src={c.cover}
          alt={`${c.client} — ${t(c.title)}`}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-contain transition-transform duration-700 ease-out group-hover:scale-[1.015]"
          fallbackClassName="h-full w-full"
        />
      </div>

      <div className="portfolio-card-body">
        <div className="flex items-start justify-between gap-5">
          <div className="min-w-0">
            {c.logo ? (
              <div className="mb-5 flex h-10 max-w-[170px] items-center">
                <SafeImage src={c.logo} alt={`${c.client} logo`} className="max-h-full max-w-full object-contain object-left" />
              </div>
            ) : (
              <p className="eyebrow-soft mb-3">{t(c.segment || c.sector)}</p>
            )}
            <p className="portfolio-client">{c.client}</p>
          </div>
          <ArrowUpRight className="mt-1 h-5 w-5 shrink-0 opacity-45 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:opacity-100" />
        </div>

        <Heading className="portfolio-title mt-5">{t(c.title)}</Heading>
        <p className="portfolio-summary mt-4">{t(c.summary)}</p>

        {c.scope?.length > 0 && (
          <div className="mt-6 flex flex-wrap gap-x-4 gap-y-2">
            {c.scope.slice(0, 4).map((s) => (
              <span key={s} className="portfolio-scope">{t(s)}</span>
            ))}
          </div>
        )}

        <div className="portfolio-meta mt-7 flex items-center justify-between gap-4 pt-5">
          <span>{t("View project")}</span>
          <span>{workCount} {t("selected works")}</span>
        </div>
      </div>
    </Link>
  );
};

export { caseDisclaimer };
